export default "__VITE_ASSET__BTBhbZnU__"